import React, { ReactNode } from 'react';
import Modal from '@mui/material/Modal';
import './CenteredModal.styles.scss';
import { IconButton } from '@mui/material';
import { HighlightOffRounded } from '@mui/icons-material';



type TModalProps = {
    open: boolean,
    onClose: ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void) | undefined , 
    closeClick: () => void,
}

const CenteredModal:React.FC<TModalProps & {children:ReactNode}> = ({
    open,
    onClose,
    closeClick,
    children
}) => {




  return (
    <Modal
        open={open}
        onClose={onClose}
        closeAfterTransition
      >
        
          <div className='middle-modal-container'>
                <IconButton className='close-icon'
                        size="large" 
                        color='inherit'
                        onClick={closeClick}>
                    <HighlightOffRounded />
                </IconButton>
            {children}
          </div>
      </Modal>
  )
}

export default CenteredModal;